if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.productImageURL = document.querySelector('.product-featured-image').getAttribute('data-src');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        /** -------------------------------
         *  ✅ NEW VALIDATION ADDED HERE
         *  Prevent add-to-cart if no size selected
         *  ------------------------------- */
        const tempFormData = new FormData(this.form);
        const selectedVariantId = tempFormData.get('id');
        const selectedSize =
          tempFormData.get('options[Size]') ||
          tempFormData.get('option1') ||
          '';
        const sizeSelect =
          this.form.querySelector('[name="options[Size]"], select[name*="size"], .size-selector select');

        const invalidVariant =
          !selectedVariantId ||
          selectedVariantId === 'undefined' ||
          selectedVariantId === 'null' ||
          selectedVariantId === '';

        const sizeExistsButNotSelected =
          sizeSelect &&
          (!selectedSize ||
            selectedSize === '' ||
            selectedSize === '—' ||
            selectedSize === 'Choose a size');

        if (invalidVariant || sizeExistsButNotSelected) {
          const $customButton = $('.size-drpdwn-toggle.button');
          window.globalState.customButtonTriggeredProgrammatically = true;
          $customButton.trigger('click');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          document.getElementById('atc-overlay')?.classList.add('hidden');
          return; // stop add-to-cart
        }
        /** ------------------------------- */

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        document.getElementById('atc-overlay')?.classList.remove('hidden');
        // this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description, response);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.showRecentlyAddedProductPopup(response);
            getCartData().then((cartData) => {
              if (cartData) {
                window.cartBloom_requestStarted(cartData, this.submitButton);
                window.cartBloom_requestComplete(cartData, this.submitButton);
              }
            });
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error)
              this.submitButton.removeAttribute('aria-disabled');
            document
              .getElementById('atc-overlay')
              ?.classList.add('hidden');
            // this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      showRecentlyAddedProductPopup(response, errorMessage = null) {
        const langCode = window.globalState.shopLocale;
        const popup = document.getElementById('recently-added-popup');
        if (!popup) return; // Prevent crash if popup section is removed
        const newpop = document.querySelector('.cart-drawer__overlay-pop');
        const newpopshow = document.querySelector('body');
        const productImage =
          response?.featured_image?.url.replace(
            /(\.(jpg|jpeg|png|webp))(\?.*)?$/i,
            '_100x100$1'
          ) ||
          this.productImageURL.replace(
            /(\.(jpg|jpeg|png|webp))(\?.*)?$/i,
            '_100x100$1'
          );
        const productTitle = response?.product_title;
        const productTitles = response?.options_with_values;
        const sizeOption = productTitles?.find(
          (opt) => opt.name === 'Size' || opt.name === 'المقاس'
        )?.value;
        const titleElement = document.getElementById('recently-added-title');
        const sizeElement = document.getElementById('recently-added-size');
        document.getElementById('recently-added-image').src = productImage;
        if (errorMessage) {
          if (langCode === 'ar') {
            titleElement.textContent =
              'تم الوصول إلى الحد الأقصى للكمية لنفس المرجع';
          } else {
            titleElement.textContent =
              'Maximum quantity reached for the same reference';
          }
          titleElement.style.color = '#d9490f';
        } else {
          if (langCode === 'ar') {
            titleElement.textContent = productTitle;
            sizeElement.textContent = ' المقاس ' + sizeOption;
          } else {
            titleElement.textContent = productTitle;
            sizeElement.textContent = 'SIZE ' + sizeOption;
          }
        }
        setTimeout(() => {
          popup.classList.remove('out');
          popup.style.opacity = 1;
          popup.style.visibility = 'visible';
          if (newpop) {
            newpop.style.display = 'block';
            newpopshow.classList.add('overflow-hidden');
          }
        }, 1000);

        updatePopupPosition();
        window.addEventListener('resize', updatePopupPosition);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          const $customButton = $('.size-drpdwn-toggle.button');
          window.globalState.customButtonTriggeredProgrammatically = true;
          $customButton.trigger('click');
          if (errorMessage.startsWith("You can't add more")) {
            this.showRecentlyAddedProductPopup(
              {
                featured_image: { url: this.productImageURL },
              },
              errorMessage
            );
            this.errorMessageWrapper.toggleAttribute('hidden');
          } else {
            this.errorMessageWrapper.toggleAttribute('hidden');
          }
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
function updatePopupPosition() {
  const header = document.querySelector('header');
  const popup = document.getElementById('recently-added-popup');
  if (header) {
    const headerHeight = header.offsetHeight;
    popup.style.top = `${headerHeight}px`;
  }
}
